<template>
	<v-container fluid>
		<v-layout row wrap>
			<v-flex xs12>
				<v-btn
					@click="addClick"
					class="ml-0"
					color="success"
					v-if="
						$myStore.state.user.user_role_id != 2 &&
							$myStore.state.user.user_role_id != 4
					"
				>
					<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{
						$t("buttons.addTour")
					}}
				</v-btn>
				<v-btn
					@click="assignGuideClick"
					class="ml-0"
					color="success"
					v-if="
						markedRecords.length != 0 &&
							$myStore.state.user.user_role_id != 2
					"
				>
					<v-icon small>fa-user-plus</v-icon>&nbsp;&nbsp;{{
						$t("buttons.assignGuide")
					}}
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card class="elevation-0 background-transparent">
					<DataTable
						:additional-filters="toursTable.additionalFilters"
						:excel="true"
						:headers="toursTable.headers"
						:items="toursTable.items"
						:total="toursTable.total"
						@excel="excelExport"
						@reload="reloadData"
					>
						<template #row="props">
							<tr
								:class="{
									'cursor-pointer': true,
									'tour-cancelled-row': props.item.cancelled
								}"
								@contextmenu.prevent="
									editClick(props.item.id, true)
								"
							>
								<td>
									<v-tooltip
										bottom
										v-if="
											$myStore.state.user.user_role_id !=
												2
										"
									>
										<v-checkbox
											:value="props.item.id"
											hide-details
											slot="activator"
											v-model="markedRecords"
										></v-checkbox>
										<span>{{
											$t("tooltips.markTour")
										}}</span>
									</v-tooltip>
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.id }}
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.name }}
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.first_buyer_name }}
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.tour_category.name }}
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.destination.name }}
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.start_date_display }}
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.guides_display }}
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.guests_display }}
								</td>
								<td
									class="tour-row-icons"
									@click="editClick(props.item.id, false)"
								>
									<template
										v-if="props.item.guests_display > 0"
									>
										<v-tooltip
											bottom
											v-if="props.item.mails_sent"
										>
											<v-icon
												class="mr-2, primary--text"
												slot="activator"
											>
												fa-envelope
											</v-icon>
											<span>{{
												$t("labels.formsSent")
											}}</span>
										</v-tooltip>
										<v-tooltip
											bottom
											v-if="!props.item.mails_sent"
										>
											<v-icon
												class="mr-2, error--text"
												slot="activator"
											>
												fa-envelope
											</v-icon>
											<span>{{
												$t("labels.formsNotSent")
											}}</span> </v-tooltip
										>&nbsp;
										<v-tooltip
											bottom
											v-if="props.item.deposits_paid"
										>
											<v-icon
												class="mr-2, primary--text"
												slot="activator"
											>
												fa-coins
											</v-icon>
											<span>{{
												$t("labels.depositsPaid")
											}}</span>
										</v-tooltip>
										<v-tooltip
											bottom
											v-if="!props.item.deposits_paid"
										>
											<v-icon
												class="mr-2, error--text"
												slot="activator"
											>
												fa-coins
											</v-icon>
											<span>{{
												$t("labels.depositsNotPaid")
											}}</span> </v-tooltip
										>&nbsp;
										<v-tooltip
											bottom
											v-if="props.item.balances_paid"
										>
											<v-icon
												class="mr-2, primary--text"
												slot="activator"
											>
												fa-money-bill
											</v-icon>
											<span>{{
												$t("labels.balancesPaid")
											}}</span>
										</v-tooltip>
										<v-tooltip
											bottom
											v-if="!props.item.balances_paid"
										>
											<v-icon
												class="mr-2, error--text"
												slot="activator"
											>
												fa-money-bill
											</v-icon>
											<span>{{
												$t("labels.balancesNotPaid")
											}}</span> </v-tooltip
										>&nbsp;
									</template>
									<template
										v-if="props.item.services.length > 0"
									>
										<v-tooltip
											bottom
											v-if="!props.item.services_paid"
										>
											<v-icon
												class="mr-2, error--text"
												slot="activator"
											>
												fa-home
											</v-icon>
											<span>{{
												$t("labels.servicesNotPaid")
											}}</span>
										</v-tooltip>
										<v-tooltip
											bottom
											v-if="props.item.services_paid"
										>
											<v-icon
												class="mr-2, primary--text"
												slot="activator"
											>
												fa-home
											</v-icon>
											<span>{{
												$t("labels.servicesPaid")
											}}</span>
										</v-tooltip>
									</template>
								</td>
								<td @click="editClick(props.item.id, false)">
									{{ props.item.trip_status_display }}
								</td>
								<td>
									<v-tooltip bottom>
										<v-btn
											@click="
												editClick(props.item.id, true)
											"
											icon
											slot="activator"
										>
											<v-icon small
												>fa-external-link-alt</v-icon
											>
										</v-btn>
										<span>{{
											$t("tooltips.openInNewTab")
										}}</span>
									</v-tooltip>
								</td>
							</tr>
						</template>
					</DataTable>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import DataTable from "./trinkets/DataTable";

export default {
	name: "Tours",
	components: { DataTable },
	data: function() {
		return {
			toursTable: {
				headers: [
					{
						text: "",
						value: "selection",
						type: "",
						sortable: false,
						align: "left",
						width: "50px",
						searchable: false
					},
					{
						text: this.$t("fields.id"),
						value: "id",
						type: "string",
						width: "70px",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.name"),
						value: "name",
						type: "string",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.billingPersonCompany"),
						value: "first_buyer_name",
						type: "string",
						searchable: false,
						sortable: false
					},
					{
						text: this.$t("fields.category"),
						value: "tour_category_id",
						type: "dropdown|tour-categories",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.destination"),
						value: "destination_id",
						type: "dropdown|destinations",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.startDate"),
						value: "start_date",
						type: "date_range",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.guides"),
						value: "user_id",
						type: "dropdown|users-guides",
						searchable: "hidden",
						sortable: false
					},
					{
						text: this.$t("fields.guests"),
						value: "guests",
						type: "string",
						searchable: false,
						sortable: false
					},
					{
						text: this.$t("fields.bookingStatus"),
						value: "booking_status",
						type: "string",
						searchable: false,
						sortable: false
					},
					{
						text: this.$t("fields.tripStatus"),
						value: "trip_status",
						type: "dropdown|trip-statuses",
						searchable: "hidden"
					},
					{
						text: "",
						value: "actions",
						type: "",
						sortable: false,
						align: "right",
						width: "100px",
						searchable: false
					}
				],
				items: [],
				additionalFilters: [
					{
						text: this.$t("fields.bookingFormsSent"),
						value: "booking_forms_sent",
						type: "boolean",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.depositsPaid"),
						value: "deposits_paid",
						type: "boolean",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.completelyPaid"),
						value: "completely_paid",
						type: "boolean",
						searchable: "hidden"
					},
					{
						text: this.$t("fields.servicesPaid"),
						value: "services_paid",
						type: "boolean",
						searchable: "hidden"
					}
				],
				total: 0,
				lastRequest: null
			},
			markedRecords: []
		};
	},
	methods: {
		assignGuideClick() {
			let vm = this;
			this.$dropdown(
				this.$t("labels.guide"),
				null,
				"users-guides",
				response => {
					if (response !== false && response !== null) {
						let data = {
							records: vm.markedRecords,
							guide_id: response
						};
						vm.$APICall(
							"post",
							"tours/assign-guide",
							data,
							(data, success) => {
								if (success) {
									vm.markedRecords = [];
									vm.reloadData(vm.toursTable.lastRequest);
								} else {
									vm.$alert(vm.$t("alerts.basicError"));
								}
							}
						);
					}
				}
			);
		},
		addClick() {
			this.$router.push("/tours/0");
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push("/tours/" + id);
			} else {
				let routeData = this.$router.resolve("/tours/" + id);
				window.open(routeData.href, "_blank");
			}
		},
		reloadData(request) {
			this.toursTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				"get",
				"tours",
				request,
				(data, success) => {
					if (success) {
						vm.markedRecords = [];
						vm.toursTable.items = data.items;
						vm.toursTable.total = data.total;
					} else {
						vm.$alert(vm.$t("alerts.basicError"));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(
				JSON.stringify(this.toursTable.lastRequest)
			);
			excelRequest.pagination.rowsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				"get",
				"tours",
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall(
							"post",
							"excel/tours",
							data.items,
							(data, success) => {
								window.open(data.link);
							}
						);
					} else {
						vm.$alert(vm.$t("alerts.basicError"));
					}
				},
				false
			);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace("login");
		}
		this.$setSubMenu("");
		this.$myStore.commit("setBreadcrumbs", [
			{ text: this.$t("modules.tours"), href: "/#/tours", disabled: true }
		]);
	}
};
</script>

<style scoped>
>>> .tour-cancelled-row td {
	text-decoration: line-through;
}

.tour-cancelled-row td:first-child {
	text-decoration: none;
}

.tour-cancelled-row td:last-child {
	text-decoration: none;
}

.tour-row-icons {
	text-decoration: none !important;
}
</style>
